import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import FeaturesFooter from './FeaturesFooter';
import PersonalPart from './PersonalPart';
import TeamPart from './TeamPart';

const Pricing = () => {
  const [activeTab, setActiveTab] = useState('teams');

  return (
    <div className="body">
      <Header />
     
      <div className="">
        <div id="pricing" className="section is--pricing">
          <div className="container-2">
            <div className="section-header is--pricing">
              <h4 className="h2-2 is--no-paragraph">Pricing</h4>
              <h3 className="h2-2 is--no-paragraph">Choose your plan</h3>
            </div>
            <div className="pricing__tabs">
              <div
                className={`pricing__tab is--personal selftab${activeTab === 'self' ? ' tabclassactive' : ''}`}
                onClick={() => setActiveTab('self')}
                style={{ display: 'none' }}
              >
                <div>Self Employed</div>
              </div>
              <div
                className={`pricing__tab is--teams teamtab${activeTab === 'teams' ? ' tabclassactive' : ''}`}
                onClick={() => setActiveTab('teams')}
              >
                <div>Teams</div>
              </div>
            </div>
          </div>
          <div className="container-2 is--pricing">
            {activeTab === 'self' && <PersonalPart />}
            {activeTab === 'teams' && <TeamPart />}
          </div>
        </div>
      </div>

      <FeaturesFooter />
      <Footer />
    </div>
  );
};

export default Pricing; 